import { Textarea as $Textarea } from '@mantine/core';
import type { TextareaProps as $TextareaProps } from '@mantine/core';
import { useController } from 'react-hook-form';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

import { parseError } from './lib/parseError.ts';

type TextareaProps<T extends FieldValues> = UseControllerProps<T> & Omit<$TextareaProps, 'value' | 'defaultValue'>;

export function Textarea<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  onChange,
  maxLength,
  label,
  ...props
}: TextareaProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ref: _fieldRef, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  const currentValue: unknown = value;
  const length = typeof currentValue === 'string' ? currentValue.length : 0;
  const parsedLabel = maxLength ? (
    <>
      {label} {`(${length.toLocaleString()}/${maxLength.toLocaleString()})`}
    </>
  ) : (
    label
  );

  return (
    <$Textarea
      error={parseError(label, fieldState.error)}
      value={value}
      onChange={(e) => {
        fieldOnChange(e);
        onChange?.(e);
      }}
      {...field}
      {...props}
      label={parsedLabel}
      maxLength={maxLength}
    />
  );
}
